import translationJa from './Ja/translation.json'
import translationEn from './En/translation.json'
import translationCn from './Cn/translation.json'
import i18next from 'i18next'
import { initReactI18next } from 'react-i18next'
import { getDeviceLanguageCode } from '../Utils/LanguageUtil'

const resources = {
  en: {
    translation: translationEn,
  },
  ja: {
    translation: translationJa,
  },
  cn: {
    translation: translationCn,
  },
}

i18next.use(initReactI18next).init({
  compatibilityJSON: 'v3',
  resources,
  lng: getDeviceLanguageCode(), // default language
  fallbackLng: 'ja',
})

export default i18next
